<template>
  <modal name="report-preview-items-select-modal"
         :width="`100%`"
         :height="470"
         :min-width="480"
         :min-height="360"
         :pivotX="0.5"
         :pivotY="0.5"
         :delay="100"
         :clickToClose="true"
         @before-open="beforeOpen"
  >
    <vue-scroll>
      <div class="FloatMenu md_overlay md_overlay_0 ">
        <div class="modal modal_0" style="width: 480px; margin: auto;">
          <div class="md_content">
            <h6 class="--blue70">
              {{$t('report.preview.selectItemModal.title')}}
            </h6>
            <span class="md_close">
              <img
                  src="/images/union.svg"
                  alt=""
                  @click="modalClose"
              >
            </span>
            <div class="report-body">
              <div class="report-item-select-table mt20">
                <TaggableMultipleSelect :item="item"></TaggableMultipleSelect>
              </div>
              <div class="schedule_bottom_btn">
                <div class="flex_item">
                  <a class="btn blue btn_basics pointer no-drag"
                     @click="checkValidate">
                    {{ $t('status.add') }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vue-scroll>
  </modal>
</template>
<script>
    import TaggableMultipleSelect from '@/components/Table/types/taggableMultipleSelect'
    import {_REPORT_PREVIEW_ITEMS} from "@/components/body/myPatient/report/static"

    export default {
        name: 'report-preview-items-select-modal',
        components: {
          TaggableMultipleSelect,
        },
        data() {
            const defaultClickableKeyRange = JSON.parse(JSON.stringify(_REPORT_PREVIEW_ITEMS));
            return {
                item: {
                    values: [],
                    keyRange: defaultClickableKeyRange
                },
                clickableKeyRange: defaultClickableKeyRange
            }
        },
        methods: {
            checkValidate: function () {
                if (this.item.values.length === 0) {
                    this.$modal.show( 'common-alert-modal', {
                      messageType: 'short',
                      message: 'report.preview.error.must_select_one'
                    });
                    return
                }
                this.add();
            },
            add: function () {
                this.$emit('updatePreviewItems', this.item.values);
                this.modalClose();
            },
            beforeOpen(e) {
                this.clickableKeyRange = JSON.parse(JSON.stringify(_REPORT_PREVIEW_ITEMS));

                const alreadyClickedItems = JSON.parse(JSON.stringify(e.params?.reportPreviewItems ?? []))
                if (alreadyClickedItems.length !== 0) {
                    alreadyClickedItems.forEach(it => {
                        this.clickableKeyRange.removeItemByKeyMatch('value', it.value);
                    })
                }
                this.item.values = alreadyClickedItems;
            },
            modalClose: function () {
                this.$modal.hide('report-preview-items-select-modal');
            }
        }
    }
</script>
<style lang="scss">
.v--modal-overlay[data-modal="report-preview-items-select-modal"] {
  .md_content {
    height: 280px;

    .report-body {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: stretch;
      height: 190px;

      & .report-item-select-table {
        height: 130px;
      }
    }
  }

  .vs__dropdown-toggle {
    height: 120px !important;
    overflow: auto;

    .vs__selected-options {
      margin: 0;
      padding: 0;
      .vs__selected {
        margin: 5px;
        padding: 0 1em 0 1em;
      }
    }
  }
}
</style>